import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from '@design-system';
import { TestCaseForm } from '@/features/wizard-evals/components/TestCaseForm';
import { TestCaseRunPanel } from '@/features/wizard-evals/components/TestCaseRunPanel';
import type { WizardEvalTestCase } from '@/features/wizard-evals/api/wizard-evals-api';

interface TestCaseAccordionItemProps {
  testCase: WizardEvalTestCase;
}

export function TestCaseAccordionItem({ testCase }: TestCaseAccordionItemProps) {
  return (
    <AccordionItem
      value={testCase.testCaseId}
      className="bg-white hover:bg-white data-[state=open]:bg-white"
    >
      <AccordionTrigger>
        <div className="flex w-full items-center justify-between gap-3 pr-2">
          <div className="min-w-0 flex-1">
            <p className="max-w-md truncate text-sm font-medium text-gray-900">
              {testCase.name}
            </p>
            <p className="truncate text-xs text-gray-600">
              {testCase.carrier} · expected: {testCase.expectedOutcome}
              {testCase.expectedRateClass ? ` (${testCase.expectedRateClass})` : ''}
              {testCase.isJoint ? ' · joint' : ''}
            </p>
          </div>
          <span className="shrink-0 text-xs text-gray-600">
            {testCase.expectedRuleIds.length} expected rule
            {testCase.expectedRuleIds.length === 1 ? '' : 's'}
          </span>
        </div>
      </AccordionTrigger>
      <AccordionContent>
        <Tabs defaultValue="run">
          <TabsList className="bg-primary-100 mb-5 h-11 p-1">
            <TabsTrigger
              value="run"
              className="h-full px-6 text-base font-semibold"
            >
              Run
            </TabsTrigger>
            <TabsTrigger
              value="edit"
              className="h-full px-6 text-base font-semibold"
            >
              Edit
            </TabsTrigger>
          </TabsList>
          <TabsContent value="run">
            <TestCaseRunPanel testCase={testCase} />
          </TabsContent>
          <TabsContent value="edit">
            <TestCaseForm
              mode="edit"
              testCase={testCase}
            />
          </TabsContent>
        </Tabs>
      </AccordionContent>
    </AccordionItem>
  );
}
